import React from 'react';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import { AssignableRole } from 'src/common/roleRegistry/roleRegistry';
import RoleTile from 'src/components/ContactFormComponents/RoleTile/RoleTile';
import './role-selection-list.scss';

export interface RoleSelectionListProps {
  availableRoles: readonly AssignableRole[];
  selectedRole: AssignableRole | null;
  onSelect: (role: AssignableRole) => void;
}

const RoleSelectionList = ({
  availableRoles,
  selectedRole,
  onSelect,
}: RoleSelectionListProps) => {
  if (availableRoles.length === 0) {
    return (
      <div className="role-selection-list">
        <span className="role-selection-list-label">New role</span>
        <p className="role-selection-list-empty">
          No other roles available for this user.
        </p>
      </div>
    );
  }

  return (
    <div className="role-selection-list">
      <span className="role-selection-list-label">New role</span>
      <Row granola>
        {availableRoles.map((role: AssignableRole) => (
          <Col granola key={role} xs="6" md="4">
            <RoleTile
              role={role}
              active={role === selectedRole}
              onClick={() => onSelect(role)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default RoleSelectionList;
